export const IconPiggyBank = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconPiggyBank_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconPiggyBank_svg__a)">
        <path d="M5.925 21q-.575 0-1.112-.4t-.713-.975q-.625-2.1-1.025-3.637a53 53 0 0 1-.638-2.7 23 23 0 0 1-.337-2.063Q2 10.325 2 9.5q0-2.3 1.6-3.9T7.5 4h5q.674-.9 1.713-1.45A4.8 4.8 0 0 1 16.5 2q.625 0 1.063.438a1.45 1.45 0 0 1 .4 1.362q-.039.15-.088.275-.101.275-.187.55a4 4 0 0 0-.138.6L19.825 7.5H21q.424 0 .712.287.288.288.288.713v5.25a.93.93 0 0 1-.187.575 1.13 1.13 0 0 1-.513.375l-2.125.7-1.25 4.175q-.2.65-.725 1.038Q16.675 21 16 21h-2q-.825 0-1.412-.587A1.93 1.93 0 0 1 12 19h-2q0 .824-.588 1.413A1.93 1.93 0 0 1 8 21zM6 19h2v-2h6v2h2l1.55-5.15 2.45-.825V9.5h-1L15.5 6q0-.5.063-.975.062-.475.187-.925a3.2 3.2 0 0 0-1.275.688q-.55.487-.8 1.212H7.5Q6.05 6 5.025 7.025A3.37 3.37 0 0 0 4 9.5q0 1.025.525 3.512Q5.05 15.502 6 19m10-8q.424 0 .712-.287A.97.97 0 0 0 17 10a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 9a.97.97 0 0 0-.713.287A.97.97 0 0 0 15 10q0 .424.287.713.288.287.713.287m-4-2q.424 0 .713-.287A.97.97 0 0 0 13 8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7H9a.97.97 0 0 0-.713.287A.97.97 0 0 0 8 8q0 .424.287.713Q8.576 9 9 9z" />
      </g>
    </svg>
  );
};
